export default __webpack_public_path__ + "static/media/login-background.81a0255c.jpg";